/**
 * @generated SignedSource<<b16e73894c477e3b6ba0a2fe2ad7552d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AssignmentStudentAssignmentQuery$variables = {
  assignmentId: string;
  skip?: boolean | null | undefined;
};
export type AssignmentStudentAssignmentQuery$data = {
  readonly assignment?: {
    readonly createdBy: {
      readonly firstName: string | null | undefined;
      readonly id: string;
      readonly lastName: string | null | undefined;
    } | null | undefined;
    readonly dueOn: any;
    readonly id: string;
    readonly name: string | null | undefined;
    readonly skill: {
      readonly code: string | null | undefined;
      readonly id: string;
      readonly name: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly studentSkillAssignments: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly skill: {
        readonly code: string | null | undefined;
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
      readonly skillAssessment: {
        readonly score: number;
      } | null | undefined;
      readonly submittedOn: any | null | undefined;
    }> | null | undefined;
  } | null | undefined;
};
export type AssignmentStudentAssignmentQuery = {
  response: AssignmentStudentAssignmentQuery$data;
  variables: AssignmentStudentAssignmentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "assignmentId"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = {
  "kind": "Variable",
  "name": "assignmentId",
  "variableName": "assignmentId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "SkillNode",
  "kind": "LinkedField",
  "name": "skill",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "condition": "skip",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": [
        (v1/*: any*/)
      ],
      "concreteType": "AssignmentNode",
      "kind": "LinkedField",
      "name": "assignment",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dueOn",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UserNode",
          "kind": "LinkedField",
          "name": "createdBy",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastName",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v4/*: any*/)
      ],
      "storageKey": null
    }
  ]
},
v6 = [
  {
    "fields": [
      (v1/*: any*/),
      {
        "kind": "Literal",
        "name": "isActive",
        "value": "ACTIVE"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "submittedOn",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "score",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AssignmentStudentAssignmentQuery",
    "selections": [
      (v5/*: any*/),
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "StudentSkillAssignmentNodeConnection",
        "kind": "LinkedField",
        "name": "studentSkillAssignments",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StudentSkillAssignmentNode",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v7/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StudentSkillAssessmentNode",
                "kind": "LinkedField",
                "name": "skillAssessment",
                "plural": false,
                "selections": [
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AssignmentStudentAssignmentQuery",
    "selections": [
      (v5/*: any*/),
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "StudentSkillAssignmentNodeConnection",
        "kind": "LinkedField",
        "name": "studentSkillAssignments",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StudentSkillAssignmentNode",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v7/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StudentSkillAssessmentNode",
                "kind": "LinkedField",
                "name": "skillAssessment",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c299c805e82f6e01c881dd1355e026aa",
    "id": null,
    "metadata": {},
    "name": "AssignmentStudentAssignmentQuery",
    "operationKind": "query",
    "text": "query AssignmentStudentAssignmentQuery(\n  $assignmentId: ID!\n  $skip: Boolean = false\n) {\n  assignment(assignmentId: $assignmentId) @skip(if: $skip) {\n    id\n    name\n    dueOn\n    createdBy {\n      id\n      firstName\n      lastName\n    }\n    skill {\n      id\n      name\n      code\n    }\n  }\n  studentSkillAssignments(filter: {assignmentId: $assignmentId, isActive: ACTIVE}) {\n    nodes {\n      id\n      submittedOn\n      skill {\n        id\n        name\n        code\n      }\n      skillAssessment {\n        score\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "02dd64f6d1f24a003fb249bae409a0e0";

export default node;
